import { render, staticRenderFns } from "./LVideo.vue?vue&type=template&id=0c16ad89&scoped=true&"
import script from "./LVideo.vue?vue&type=script&lang=js&"
export * from "./LVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c16ad89",
  null
  
)

export default component.exports